import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices';
import dashboardReducer from './slices/dashboardSlice';
import profileReducer from './slices/profileSlice';
import patientRecordReducer from './slices/patientRecordSlice';
import pendingRequestsReducer from './slices/pendingRequestsSlice';
import cuoreCareReducer from './slices/cuoreCareSlice';
import notificationsReducer from './slices/notificationsSlice';

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    dashboard: dashboardReducer,
    profile: profileReducer,
    patientRecord: patientRecordReducer,
    pendingRequests: pendingRequestsReducer,
    cuoreCare: cuoreCareReducer,
    notifications: notificationsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false, // optional: disables warnings for non-serializable values
    }),
});

export default store;
